import { Outlet } from 'react-router-dom';
import {
  LayoutDashboard, MapPin, ListChecks, FileSpreadsheet, Sliders, Settings,
} from 'lucide-react';
import Sidebar from '../layout/Sidebar';
import TopBar from '../layout/TopBar';
import { useShop } from '../../hooks/useShop';
import { useAuth } from '../../contexts/AuthContext';

// Layout shell for /mec/* routes. Mirrors the structure of the other role
// shells (Auditor/Bookkeeper/SuperAdmin) so the chrome is consistent. We
// borrow Sidebar + TopBar read-only — no structural changes to either.
//
// Sub-routes mapped from MEC_REQUIREMENTS.md §7. Most are placeholders for
// later phases; the only live page in v1 is Account Routing.
export default function MecShell() {
  const { user } = useAuth();
  const { shops, currentShopId, switchShop } = useShop();

  const sections = [
    {
      label: 'Close',
      items: [
        { to: '/mec/today', label: 'Today', icon: <ListChecks size={14} /> },
        { to: '/mec', end: true, label: 'Dashboard', icon: <LayoutDashboard /> },
        { to: '/mec/locations', label: 'Locations', icon: <MapPin /> },
        { to: '/mec/tier-2-review', label: 'Pending Matches', icon: <ListChecks /> },
        { to: '/mec/journal-entry', label: 'Journal Entry', icon: <FileSpreadsheet /> },
      ],
    },
    {
      label: 'Settings',
      items: [
        { to: '/mec/settings/routing', label: 'Account Routing', icon: <Settings /> },
        { to: '/mec/settings/mode', label: 'Match Mode', icon: <Sliders /> },
      ],
    },
  ];

  return (
    <div className="min-h-screen flex bg-[var(--color-cream-100)] font-sans">
      <Sidebar
        brand={{ initials: 'M', name: 'Month-End Close', tagline: 'Recon · JE · Variance' }}
        sections={sections}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar
          user={user || {}}
          currentShop={currentShopId}
          shops={shops}
          onShopChange={switchShop}
          notifications={0}
        />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-[1400px] mx-auto px-6 py-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
